import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_TARIFFA_ORARIA_LIST } from '../../data.const';
import {
  setListConfigAction,
  setLoaders,
  setPopupInfo,
  storeTariffaOrariaListAction,
} from '../../data.action';
import { rootConfig } from '../../../../../config/root-config';

const retrieveTariffaOrariaListEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_TARIFFA_ORARIA_LIST),
    map(() => ({
      page: 1,
      pageSize: rootConfig.populateFields,
      order: [['nome', 'asc']],
    })),
    // tap(p => console.log(`[epic ${RETRIEVE_TARIFFA_ORARIA_LIST}]`, p)),
    withLatestFrom(state$),
    switchMap(([body, _state]) => {
      return concat(
        of(setLoaders({ onorarioLoader: true })),
        of(setListConfigAction({ role: body })),
        defer(() =>
          from(
            request({
              path: `tariffaOraria/list`,
              method: httpMethods.POST,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return { total: p?.total, result: [...p?.result] };
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_TARIFFA_ORARIA_LIST}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(data => of(storeTariffaOrariaListAction(data))),
            catchError(err => {
              console.error(
                `[epic ${RETRIEVE_TARIFFA_ORARIA_LIST}] error`,
                err
              );
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ onorarioLoader: false }))
      );
    })
  );

export default retrieveTariffaOrariaListEpic;
